module.exports = __webpack_public_path__ + "static/media/dr-arun-sherry.a367afb6.jpg";